import moment from 'moment';
import {
  MESSAGE_EVENT_CREATE_FAILED,
  MESSAGE_EVENT_CREATE_SUCCESS,
} from '../../constants/form-messages';

import {
  CREATE_EVENT,
  CREATE_EVENT_FAILED,
  CREATE_EVENT_SUCCESS,
  GET_EVENTS,
  GET_EVENT_BY_ID,
  GET_EVENT_SUCCESS,
  GET_EVENTS_FAILED,
  GET_EVENTS_SUCCESS,
  ON_CHANGE_TAB_EVENT,
  SORT_EVENTS,
  GET_PAST_EVENTS,
  GET_PAST_EVENTS_SUCCESS,
  GET_PAST_EVENTS_FAILED,
  CANCEL_EVENT,
  CANCEL_EVENT_SUCCESS,
  CANCEL_EVENT_FAILED,
  GET_FILTERED_EVENTS,
  GET_FILTERED_EVENTS_FAILED,
  GET_FILTERED_EVENTS_SUCCESS,
  RESET_FILTERED_EVENTS,
  UPDATE_EVENT,
  UPDATE_EVENT_FAILED,
  UPDATE_EVENT_SUCCESS,
  RESET_UPDATE_EVENT_FORM,
  SET_EVENT,
  SEND_NOTIFICATION_SMS_TO_VENDORS,
  SEND_NOTIFICATION_SMS_TO_VENDORS_SUCCESS,
  SEND_NOTIFICATION_SMS_TO_VENDORS_FAILED,
  ON_DISPLAY_MODAL_SMS,
  DISABLE_EVENT,
  SET_MANAGE_EVENT_TAB,
  GET_DIGITAL_MARKETING,
  GET_DIGITAL_MARKETING_FAILED,
  GET_DIGITAL_MARKETING_SUCCESS,
  CHANGE_LOADING,
} from './constants';

const initialState = {
  tabsEvent: [
    { id: 1, name: 'Manage Events', active: true },
    { id: 6, name: 'Manage Retail Spaces', active: false },
    { id: 2, name: 'Create Event', active: false },
    { id: 5, name: 'Create Recurring Events', active: false },
    //  { id: 7, name: 'Create Retail Space', active: false },
    { id: 8, name: 'Create Retail Profile', active: false },
    { id: 4, name: 'Rate Your Vendors', active: false },
  ],
  currentTab: 1,
  event: {},
  eventList: [],
  pastEvents: [],
  filteredEvents: [],
  originalEventList: [],
  error: null,
  loading: false,
  successMessage: undefined,
  failedMessage: undefined,
  displayModalSMS: false,
  manageEventTab: 0,
  urlData: undefined,
};

function compareName(a, b) {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return 0;
}

const eventReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case CREATE_EVENT:
    case GET_EVENT_BY_ID:
      return { ...state, loading: true };
    case CREATE_EVENT_SUCCESS:
      return { ...state, loading: false };
    case CREATE_EVENT_FAILED:
      return {
        ...state,
        error: action.payload.error,
        failedMessage: MESSAGE_EVENT_CREATE_FAILED,
        successMessage: undefined,
        loading: false,
      };
    case UPDATE_EVENT:
      return {
        ...state,
        loading: true,
        successMessage: undefined,
        failedMessage: undefined,
      };
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: true,
        failedMessage: false,
      };
    case UPDATE_EVENT_FAILED:
      return {
        ...state,
        loading: false,
        successMessage: false,
        failedMessage: action.payload.error,
      };
    case SEND_NOTIFICATION_SMS_TO_VENDORS:
      return { ...state, loading: true };
    case SEND_NOTIFICATION_SMS_TO_VENDORS_SUCCESS:
      return { ...state, displayModalSMS: false, loading: false };
    case SEND_NOTIFICATION_SMS_TO_VENDORS_FAILED:
      return { ...state, displayModalSMS: false, loading: false };
    case GET_EVENTS:
    case GET_PAST_EVENTS:
    case GET_FILTERED_EVENTS:
    case GET_EVENT_SUCCESS:
      return { ...state, event: action.payload?.event, loading: false };
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        eventList: action.payload.eventList,
        originalEventList: action.payload.eventList,
        loading: false,
      };
    case GET_PAST_EVENTS_SUCCESS:
      return { ...state, pastEvents: action.payload.pastEvents, loading: false };
    case GET_FILTERED_EVENTS_SUCCESS:
      return { ...state, filteredEvents: action.payload.filteredEvents, loading: false };
    case GET_EVENTS_FAILED:
    case GET_PAST_EVENTS_FAILED:
    case GET_FILTERED_EVENTS_FAILED:
    case RESET_FILTERED_EVENTS:
      return { ...state, filteredEvents: [] };
    case GET_DIGITAL_MARKETING:
    case GET_DIGITAL_MARKETING_SUCCESS:
      return { ...state, urlData: action.payload.urlData, loading: false };
    case RESET_UPDATE_EVENT_FORM:
      return {
        ...state,
        successMessage: undefined,
        failedMessage: undefined,
      };

    case SORT_EVENTS: {
      const { sortBy } = action.payload;
      console.log('Sort value received:', sortBy);
      const currentDate = moment();

      const eventList = {
        all: [...state.originalEventList],
        current: [...state.originalEventList]
          .filter((event) => {
            const eventDate = event.parameters_event?.event_date;
            return (
              eventDate && moment(eventDate).isValid() && moment(eventDate).isAfter(currentDate)
            );
          })
          .sort(
            (a, b) => moment(a.parameters_event.event_date) - moment(b.parameters_event.event_date),
          ),
        past: [...state.originalEventList]
          .filter((event) => {
            const eventDate = event.parameters_event?.event_date;
            return (
              eventDate && moment(eventDate).isValid() && moment(eventDate).isBefore(currentDate)
            );
          })
          .sort(
            (a, b) => moment(b.parameters_event.event_date) - moment(a.parameters_event.event_date),
          ),
      };

      return {
        ...state,
        eventList: eventList[sortBy] || state.originalEventList,
      };
    }

    case ON_CHANGE_TAB_EVENT: {
      const { tab } = action.payload;
      return {
        ...state,
        currentTab: tab,
        tabsEvent: state.tabsEvent.map((item) =>
          item.id === action.payload.tab ? { ...item, active: true } : { ...item, active: false },
        ),
      };
    }
    case CHANGE_LOADING: {
      const { newStatus } = action.payload;
      return { ...state, loading: newStatus };
    }
    case CANCEL_EVENT:
    case DISABLE_EVENT:
      return { ...state, loading: true };
    case CANCEL_EVENT_SUCCESS: {
      const { eventId } = action.payload;
      return {
        ...state,
        eventList: state.eventList.map((item) =>
          item.id === eventId ? { ...item, status: false } : item,
        ),
        loading: false,
      };
    }
    case CANCEL_EVENT_FAILED:
      return { ...state, loading: false };
    case GET_DIGITAL_MARKETING_FAILED:
      return { ...state, loading: false };
    case SET_EVENT:
      return {
        ...state,
        event: action.payload.event,
        successMessage: undefined,
        failedMessage: undefined,
      };
    case SET_MANAGE_EVENT_TAB: {
      const { tab } = action.payload;
      return {
        ...state,
        manageEventTab: tab,
      };
    }
    case ON_DISPLAY_MODAL_SMS:
      return { ...state, displayModalSMS: action.payload.status };
    default:
      return state;
  }
};

export default eventReducer;
